import { Directive } from "@angular/core";

@Directive({
  host: {
    // tw-shadow-sm added for the Vault Prolinkdigital card-based UI pattern (subtle
    // elevation on every bit-card/bit-base-card, matching the reference design) — the
    // component doc comment already claimed "border and box-shadow" but shadow was
    // previously missing from this class list.
    class:
      "tw-box-border tw-block tw-bg-bg-primary tw-text-fg-heading tw-border tw-border-solid tw-border-border-base tw-rounded-xl tw-shadow-sm",
  },
})
export class BaseCardDirective {}
